import { useMemo } from "react";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { getRedirectUrlWithoutHostname } from "@iddataweb/idw-common-ui/utils";
import { InputFormGroup } from "@containers/common/input-form-group/input-form-group";
import { ClickableIcon } from "@containers/common/clickable-icon/clickable-icon";
import { LayoutTypes } from "@enums/layout-types";
import { LabelWidthTypes } from "@enums/label-width-types";
import styles from "./static-landing-page-container.less";
import { RedirectUrlOriginTypes } from "@enums/redirect-url-origin-types";
import { RedirectUrlOriginBadge } from "@containers/verification-service-details/verification-service-details-tab-container/verification-service-details-theming-tab/theming-landing-page-tab-container/redirect-url-origin-badge/redirect-url-origin-badge";

type StaticLandingPageContainerProps = {
    index: number;
    showOriginBadge: boolean;
    redirectUrl: string;
    redirectUrlOrigin: RedirectUrlOriginTypes;
    layout: LayoutTypes;
    labelWidth: LabelWidthTypes;
    isDisabled: boolean;
    handleRemoveRedirect: (index: number, redirectUrlOrigin: RedirectUrlOriginTypes) => void;
};

export const StaticLandingPageContainer = (props: StaticLandingPageContainerProps) => {
    const {
        index,
        showOriginBadge,
        redirectUrl,
        redirectUrlOrigin,
        layout,
        labelWidth,
        isDisabled,
        handleRemoveRedirect
    } = props;

    const redirectUrlForDisplay = useMemo(() => {
        return getRedirectUrlWithoutHostname(redirectUrl);
    }, [redirectUrl]);

    const handleClickDeleteRedirectUrl = () => {
        handleRemoveRedirect(index, redirectUrlOrigin);
    };

    const afterInputElement = useMemo(() => {
        return (
            <div className={styles.buttonContainer}>
                {showOriginBadge && (
                    <RedirectUrlOriginBadge redirectUrlOrigin={redirectUrlOrigin} />
                )}
                {!isDisabled && (
                    <ClickableIcon
                        controlId={`delete-static-landing-page-${redirectUrl}-${index}`}
                        disabled={isDisabled}
                        icon={faTrash}
                        onClick={handleClickDeleteRedirectUrl}
                        className={styles.afterInputIcon}
                    />)}
            </div>
        );
    }, [
        isDisabled,
        redirectUrlOrigin,
        redirectUrlForDisplay,
        index,
        showOriginBadge,
        handleClickDeleteRedirectUrl
    ]);

    return (
        <InputFormGroup
            automationId={`landing-page-${redirectUrl}-page-name-input`}
            controlId={`landing-page-${redirectUrl}-page-name-input`}
            disabled={true}
            isRequired={true}
            onChange={() => { }}
            value={redirectUrlForDisplay}
            label={null}
            labelWidth={labelWidth}
            layout={layout}
            afterInputElement={afterInputElement}
        />
    );
};